import { Color } from '@kite-js/theme-types';

const green: Color = {
    50: '#E6F3E6',
    100: '#B3E5E2',
    200: '#4DC3BA',
    300: '#008A05',
    400: '#00877E',
    500: '#006E04',
};

export default green;
